import WebsiteElement from "./WebsiteElement";

export default class ContainerBlock extends WebsiteElement {
    /**
     * @param {HTMLElement} element
     */
    constructor(element) {
        super(element);

        this.animateInTiming = 2000;
    }

    /**
     * Kijkt of het element een instantie van dit object moet krijgen.
     *
     * @param {HTMLElement} element
     *
     * @returns {boolean}
     */
    static is(element) {
        return element.classList.contains('gb-block-container');
    }
}
